module.exports = __webpack_public_path__ + "static/media/2.97b7c39e.jpg";